module.exports = __webpack_public_path__ + "static/media/checked-step.c3544c26.svg";